import { useIsDesktop } from '@/hooks/useIsDesktop';
import { DesktopCatalog } from './desktop/DesktopCatalog';
import { MobileCatalog } from './mobile/MobileCatalog';

export function LearnerCatalog() {
  return useIsDesktop() ? <DesktopCatalog /> : <MobileCatalog />;
}
